import { RIGHTS } from 'core-uda/Rights'
import { hasYamlRight } from './deprecatedLayers.utils'

export function deprecatedBathymetryLayer() {
  if (hasYamlRight('bathymetry')) return {}

  const bathymetryUrl = RIGHTS('map.layers.bathymetry.url', '')

  if (!bathymetryUrl) return {}

  let type = '',
    url = ''

  const arr = bathymetryUrl.split(' ')
  if (arr[0]) {
    type = arr[0]
  }
  if (arr.length > 1 && arr[1]) {
    url = arr[1]
  }

  const centerZoomFactor = RIGHTS('map.layers.zoomFactor', 1)

  return {
    type,
    url,
    data: { icon: 'isoline' },
    maxZoom: 19 * centerZoomFactor,
    zoomFactor: centerZoomFactor === 1 ? 2 : 1.5,
  }
}
